module.exports = __webpack_public_path__ + "static/media/hbb_banner_element.538be04c.png";